module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/efo_features_01-c1bb2ab298af7589d1385da8cbd4ca47.png";